"use client";

import Script from "next/script";
import {
  getGoogleAdsConversionId,
  getGoogleAnalyticsMeasurementId,
} from "@/lib/analytics-config";

type GoogleAnalyticsProps = {
  googleAdsConversionId?: string | null;
};

export default function GoogleAnalytics({
  googleAdsConversionId,
}: GoogleAnalyticsProps = {}) {
  const analyticsId = getGoogleAnalyticsMeasurementId();
  const adsConversionId =
    googleAdsConversionId?.trim() || getGoogleAdsConversionId();

  // Do not track in development
  if (process.env.NODE_ENV !== "production") {
    return null;
  }

  if (!analyticsId && !adsConversionId) {
    return null;
  }

  const tagId = analyticsId || adsConversionId;

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${tagId}`}
        strategy="afterInteractive"
      />
      <Script id="ga-init" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          ${analyticsId ? `gtag('config', '${analyticsId}', { send_page_view: false });` : ""}
          ${adsConversionId ? `gtag('config', '${adsConversionId}');` : ""}
        `}
      </Script>
    </>
  );
}
